const hasSubscriberPrivilege = currentUser =>
  ['admin', 'operator'].includes(currentUser?.userType) ||
  currentUser?.subscribed

export default hasSubscriberPrivilege
